import { instance as axios } from "@/services/axios";
export default {
  async GetSalesChannel(form) {
    try {
      var response = await axios.get(
        `/SellChannel?search=${form.search}&page=${form.page}&take=${form.take}`
      );
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetSalesChannelByID(id) {
    try {
      var response = await axios.get(`/SellChannel/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateSalesChannel(form) {
    try {
      var response = await axios.post(`/SellChannel`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdatetSalesChannel(form) {
    try {
      var response = await axios.put(`/SellChannel`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async DeleteSalesChannel(id) {
    try {
      var response = await axios.delete(`/SellChannel/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
};
